import styled from '@emotion/styled';
import {
    Button,
    BulletList,
    Heading2,
    Heading3,
    Radio,
    Divider,
    TextField,
    Modal
} from '@blueprint/ui';
import { css } from '@emotion/react';

const ModalBody = styled(Modal)(
    () => css`
        height: 2.5rem;
    `
);

const HorizontalDivider = styled(Divider)(
    () => css`
        position: inherit;
        margin: 0;
        margin-top: 16px;
    `
);

const Container = styled('div')(
    () => css`
        display: flex;
        flex-direction: column;
        max-width: none;
        margin: 0;
    `
);

const AlertModalHeading = styled(Heading2)(
    (props) => css`
        margin-top: ${props.theme.spacing['8px']};
        margin-bottom: ${props.theme.spacing['16px']};
    `
);

const BulletColor = styled(BulletList)(
    (props) => css`
        color: ${props.theme.colors['grey-steel']};
        > li {
            margin: 0;
        }
    `
);

const AlertModalSubHeading = styled(Heading3)(
    (props) => css`
        margin-top: ${props.theme.spacing['16px']};
        margin-bottom: ${props.theme.spacing['16px']};
    `
);

const AlertContextText = styled('p')(
    ({ theme }) => css`
        margin: 0 0 ${theme.spacing['16px']} 0;
        line-height: ${theme.type.lineHeight};
        font-size: ${theme.type.secondary};
        color: ${theme.colors['grey-slate']};
    `
);

const AlertModalOptions = styled(Radio)(
    (props) => css`
        margin-top: ${props.theme.spacing['16px']};
    `
);

const AlertModalName = styled(TextField)(
    (props) => css`
        margin-bottom: ${props.theme.spacing['16px']};
    `
);

const ButtonForm = styled(Button)(
    (props) => css`
        margin-top: ${props.theme.spacing['16px']};
    `
);

export {
    ButtonForm,
    Container,
    BulletColor,
    AlertModalHeading,
    AlertModalSubHeading,
    AlertContextText,
    AlertModalOptions,
    HorizontalDivider,
    AlertModalName,
    ModalBody
};
